import type { DailyRewardPopupLayout } from '../../../layouts/popups/DailyRewardPopupLayout';

export class DailyRewardPathHandler {
  constructor(
    private readonly layout: DailyRewardPopupLayout,
    initOpenedRewards: number,
  ) {
    this.init(initOpenedRewards);
  }

  public init(initOpenedRewards: number): void {
    const {
      layout: { roadLink, roadDot },
    } = this;

    roadDot.forEach((dot, index) => {
      if (index < initOpenedRewards) {
        dot.props({
          texture: 'Checked_Position_Dot',
        });
      } else if (index > initOpenedRewards) {
        dot.visible = false;
      }
    });

    roadLink.forEach((link, index) => {
      link.visible = index <= initOpenedRewards - 2;
    });
  }

  public openNextReward(): void {
    const {
      layout: { roadLink, roadDot },
    } = this;

    const nextLink = roadLink.find((link) => !link.visible);
    const currentDot = roadDot.findLast((dot) => dot.visible);
    const nextDot = roadDot.find((dot) => !dot.visible);

    currentDot?.props({
      texture: 'Checked_Position_Dot',
    });
    nextLink?.props({ visible: true });
    nextDot?.props({ visible: true });
  }
}
